// extracted by mini-css-extract-plugin
export default {"listCards":"InspirationsList_listCards__5ZWyQ"};